import React from 'react';
import { Search, Code, CheckCircle } from 'lucide-react';
import { howItWorks } from '../data/mock';

const iconMap = {
  Search: Search,
  Code: Code,
  CheckCircle: CheckCircle
};

const HowItWorks = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-blue-50/30 to-white" id="how-it-works">
      <div className="container mx-auto px-6">
        <h2 className="text-4xl md:text-5xl font-bold text-center text-[#0E3A5F] mb-4">
          How It Works
        </h2>
        <p className="text-xl text-center text-gray-600 mb-16 max-w-2xl mx-auto">
          Three simple steps to transform your SaaS spending into software ownership
        </p>

        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8">
            {howItWorks.map((step, index) => {
              const Icon = iconMap[step.icon];
              return (
                <div 
                  key={step.step}
                  className="relative bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 border-2 border-gray-100 hover:border-[#7AC943] group"
                >
                  {/* Step Number */}
                  <div className="absolute -top-6 left-8 bg-gradient-to-br from-[#1F6FB2] to-[#7AC943] text-white w-12 h-12 rounded-full flex items-center justify-center text-xl font-bold shadow-lg">
                    {step.step}
                  </div>

                  {/* Icon */}
                  <div className="mt-8 mb-6 flex justify-center">
                    <div className="w-20 h-20 bg-gradient-to-br from-[#7AC943]/20 to-[#1F6FB2]/20 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                      <Icon className="h-10 w-10 text-[#1F6FB2]" />
                    </div>
                  </div>

                  {/* Content */}
                  <h3 className="text-2xl font-bold text-[#0E3A5F] mb-4 text-center">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed text-center">
                    {step.description}
                  </p>

                  {/* Connector Line (except for last item) */}
                  {index < howItWorks.length - 1 && (
                    <div className="hidden md:block absolute top-1/2 -right-4 w-8 h-0.5 bg-gradient-to-r from-[#1F6FB2] to-[#7AC943] z-10"></div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
